const selectors = {
  container: '.js-autopartsReturnNotificationContainer',
};

export default class ReturnsNotification {

  private readonly container: JQuery;

  constructor() {
    this.container = $(selectors.container);
    this.displayBanners();
  }

  static initAll(): ReturnsNotification {
    return new ReturnsNotification();
  }

  private displayBanners(): void {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    ReturnsNotification.getBanners()
      .done((data: string[]) => data.forEach((text): void => {
        this.container.append(
          $(`<div class="alert alert-warning mb-15">${text}</div>`),
        );
      }))
      .fail((err) => {
        // eslint-disable-next-line no-console
        console.log(err);
      });
  }

  private static getBanners(): JQuery.jqXHR {
    return $.ajax({
      url: `${window.ACC.config.encodedContextPath}/webreturns/orders/notifications`,
      method: 'GET',
    });
  }
}
